import React, { Component } from 'react'

import greenCheck from '../../../assets/images/green-check.svg'
import { Card } from '../../../components/card'
import { utcToLocalDateTime } from '../../../helpers/timeHelper'
import { displaySnakeCaseAsTitleCase } from '../../../helpers/displayFormatHelper'
import { BankAccount } from '../../../core/types'

export type Callback<T = void> = (...args: any) => T

export interface Props extends BankAccount {
  deleteAccount: Callback
}

export class PlaidCard extends Component<Props> {
  static displayName = 'PlaidCard'

  render() {
    const {
      id,
      verifiedAt,
      bankName,
      accountNumber,
      accountType,
      routingNumber,
      deletable,
      deleteAccount,
    } = this.props

    return (
      <Card title="Bank" gridClass="user-bank-accounts">
        <div className="user-bank-accounts__title">
          <p className="user-bank-accounts__bank-name">{bankName}</p>
          <img className="user-bank-accounts__verified-icon" src={greenCheck} />
        </div>
        <p className="user-bank-accounts__content">Verified by: Plaid</p>
        <p className="user-bank-accounts__content">
          Date: {utcToLocalDateTime(verifiedAt)}
        </p>
        {accountType ? (
          <p className="user-bank-accounts__content">
            Type: {displaySnakeCaseAsTitleCase(accountType)}
          </p>
        ) : (
          <p className="user-bank-accounts__content">Type:</p>
        )}
        <p className="user-bank-accounts__content">
          Account #:{' '}
          {accountNumber.replace(
            /\*+/i,
            '\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF\u25CF'
          )}
        </p>
        <p className="user-bank-accounts__content">
          Routing #: {routingNumber}
        </p>
        <div className="user-bank-accounts__footer">
          {deletable ? (
            <a
              className="button button--link-text user-bank-accounts__footer-link"
              onClick={() => deleteAccount(id)}
            >
              Delete bank account
            </a>
          ) : (
            <p className="user-bank-accounts__footer-message">In Transaction</p>
          )}
        </div>
      </Card>
    )
  }
}

export default PlaidCard
